var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M20.98 6.299v.049m0 0V17.5a4 4 0 0 1-4 4H7.02a4 4 0 0 1-4-4V6.348m17.96 0a1.06 1.06 0 0 0-.217-.872L19.126 3.1a1.59 1.59 0 0 0-1.238-.601H6.112c-.479 0-.933.22-1.238.6L3.237 5.477a1.06 1.06 0 0 0-.217.872m17.96 0c-.088.462-.472.855-1.004.855h-2.088M3.02 6.348c.088.462.472.855 1.004.855h2.088m11.776 0H6.112m11.776 0V3.032M6.112 7.202v-4.1M10.07 13.38l-2.663-.57 1.74 4.753 7.248-1.347.012-5.202-2.379 1.555-2.343-2.037-1.615 2.848Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServices);
export default __webpack_public_path__ + "static/media/services.9b61abc1dbd808ceb971c7c1d281a5e9.svg";
export { ForwardRef as ReactComponent };